import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchGroupsQueryVariables = SchemaTypes.Exact<{
  companyId: SchemaTypes.Scalars['ObjectID']['input'];
  pagination?: SchemaTypes.InputMaybe<SchemaTypes.Pagination>;
  sort?: SchemaTypes.InputMaybe<SchemaTypes.GroupSortingRule>;
  filter?: SchemaTypes.InputMaybe<SchemaTypes.GroupFilteringRule>;
}>;


export type FetchGroupsQuery = (
  { __typename: 'Query' }
  & { groups: (
    { __typename: 'PaginatedGroup' }
    & Pick<SchemaTypes.PaginatedGroup, 'count'>
    & { items: Array<(
      { __typename: 'Group' }
      & GroupListItemDataFragment
    )> }
  ) }
);

export type SubgroupListItemDataFragment = (
  { __typename: 'Subgroup' }
  & Pick<SchemaTypes.Subgroup, 'id' | 'name' | 'parentGroupId' | 'description' | 'memberCount' | 'memberUserIds' | 'createdAt' | 'updatedAt'>
);

export type Member_SuperAdminUser_Fragment = (
  { __typename: 'SuperAdminUser' }
  & Pick<SchemaTypes.SuperAdminUser, 'id' | 'firstName' | 'lastName' | 'email' | 'isSuperAdmin'>
);

export type Member_TenantUser_Fragment = (
  { __typename: 'TenantUser' }
  & Pick<SchemaTypes.TenantUser, 'id' | 'firstName' | 'lastName' | 'email'>
  & { roleAssignments: Array<(
    { __typename: 'RoleAssignment' }
    & Pick<SchemaTypes.RoleAssignment, 'role'>
    & { assignedGroups?: SchemaTypes.Maybe<Array<(
      { __typename: 'AssignedGroup' }
      & Pick<SchemaTypes.AssignedGroup, 'groupId' | 'subGroupIds' | 'buddyIds'>
    )>> }
  )> }
);

export type MemberFragment = Member_SuperAdminUser_Fragment | Member_TenantUser_Fragment;

export type CourseItem_CourseInstance_Fragment = (
  { __typename: 'CourseInstance' }
  & Pick<SchemaTypes.CourseInstance, 'id' | 'name' | 'description'>
);

export type CourseItem_CourseTemplate_Fragment = (
  { __typename: 'CourseTemplate' }
  & Pick<SchemaTypes.CourseTemplate, 'id' | 'name' | 'description'>
);

export type CourseItemFragment = CourseItem_CourseInstance_Fragment | CourseItem_CourseTemplate_Fragment;

export type GroupListItemDataFragment = (
  { __typename: 'Group' }
  & Pick<SchemaTypes.Group, 'id' | 'name' | 'description' | 'createdAt' | 'updatedAt' | 'isDeletable' | 'totalMemberCount' | 'enrolledCourseIds'>
  & { allMembers: Array<(
    { __typename: 'SuperAdminUser' }
    & Member_SuperAdminUser_Fragment
  ) | (
    { __typename: 'TenantUser' }
    & Member_TenantUser_Fragment
  )>, enrolledCourses: Array<(
    { __typename: 'CourseInstance' }
    & CourseItem_CourseInstance_Fragment
  ) | (
    { __typename: 'CourseTemplate' }
    & CourseItem_CourseTemplate_Fragment
  )>, subgroups: Array<(
    { __typename: 'Subgroup' }
    & SubgroupListItemDataFragment
  )> }
);

export const MemberFragmentDoc = /*#__PURE__*/ gql`
    fragment Member on User {
  ... on TenantUser {
    id
    firstName
    lastName
    email
    roleAssignments {
      role
      assignedGroups {
        groupId
        subGroupIds
        buddyIds
      }
    }
  }
  ... on SuperAdminUser {
    id
    firstName
    lastName
    email
    isSuperAdmin
  }
}
    `;
export const CourseItemFragmentDoc = /*#__PURE__*/ gql`
    fragment CourseItem on Course {
  ... on CourseTemplate {
    id
    name
    description
  }
  ... on CourseInstance {
    id
    name
    description
  }
}
    `;
export const SubgroupListItemDataFragmentDoc = /*#__PURE__*/ gql`
    fragment SubgroupListItemData on Subgroup {
  id
  name
  parentGroupId
  description
  memberCount
  memberUserIds
  createdAt
  updatedAt
}
    `;
export const GroupListItemDataFragmentDoc = /*#__PURE__*/ gql`
    fragment GroupListItemData on Group {
  id
  name
  description
  createdAt
  updatedAt
  isDeletable
  totalMemberCount
  allMembers {
    ...Member
  }
  enrolledCourseIds
  enrolledCourses {
    ...CourseItem
  }
  subgroups {
    ...SubgroupListItemData
  }
}
    `;
export const FetchGroupsDocument = /*#__PURE__*/ gql`
    query FetchGroups($companyId: ObjectID!, $pagination: Pagination, $sort: GroupSortingRule, $filter: GroupFilteringRule) {
  groups(
    companyId: $companyId
    pagination: $pagination
    sort: $sort
    filter: $filter
  ) {
    count
    items {
      ...GroupListItemData
    }
  }
}
    ${GroupListItemDataFragmentDoc}
${MemberFragmentDoc}
${CourseItemFragmentDoc}
${SubgroupListItemDataFragmentDoc}`;

/**
 * __useFetchGroupsQuery__
 *
 * To run a query within a React component, call `useFetchGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchGroupsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchGroupsQuery(baseOptions: Apollo.QueryHookOptions<FetchGroupsQuery, FetchGroupsQueryVariables> & ({ variables: FetchGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchGroupsQuery, FetchGroupsQueryVariables>(FetchGroupsDocument, options);
      }
export function useFetchGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchGroupsQuery, FetchGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchGroupsQuery, FetchGroupsQueryVariables>(FetchGroupsDocument, options);
        }
// @ts-ignore
export function useFetchGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchGroupsQuery, FetchGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchGroupsQuery, FetchGroupsQueryVariables>;
export function useFetchGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchGroupsQuery, FetchGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchGroupsQuery | undefined, FetchGroupsQueryVariables>;
export function useFetchGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchGroupsQuery, FetchGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchGroupsQuery, FetchGroupsQueryVariables>(FetchGroupsDocument, options);
        }
export type FetchGroupsQueryHookResult = ReturnType<typeof useFetchGroupsQuery>;
export type FetchGroupsLazyQueryHookResult = ReturnType<typeof useFetchGroupsLazyQuery>;
export type FetchGroupsSuspenseQueryHookResult = ReturnType<typeof useFetchGroupsSuspenseQuery>;
export type FetchGroupsQueryResult = Apollo.QueryResult<FetchGroupsQuery, FetchGroupsQueryVariables>;